import { combineReducers } from 'redux'

import scorecards_center from './scorecards_center'
import popup from './popup'

export default combineReducers({
  scorecards_center,
  popup,
})
